import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Outlet, useLocation, useNavigate, useParams } from "react-router-dom";
import { BreadCrumbInfoModel } from "../../../../shared/models/breadCrumbInfo.model";
import { getAssetByCode } from "../../../../store/slices/asset.slice";
import ContentHeader from "../../../../shared/content-header/content-header.component";
import AssetActionSideBarComponent from "./components/asset-action-sidebar/asset-action-sidebar.component";
import BreadcrumbComponent from "../../../../core/components/breadcrumb/breadcrumb.component";
import getFormattedRouteEndPart from "../../../../shared/helpers/route-end-part";
import { safeAtob } from "../../../../shared/helpers/enode-decode-string";

const AssetActionComponent = () => {
  const dispatch = useDispatch();
  const params: any = useParams();
  const id = params.id ? safeAtob(params.id) : null;
  const navigate = useNavigate();

  const navigateTo = (url: string) => {
    if (url) navigate(url);
  };

  const initialBreadcrumb: BreadCrumbInfoModel = {
    label: "Asset",
    active: false,
    onClick: () => navigateTo("/asset"),
  };

  const [breadCrumbInfo, setBreadCrumbInfo] = useState<BreadCrumbInfoModel[]>(
    []
  );

  const [sideNavIdentifier, setSideNavIdentifier] = useState(null as any);

  const assetDetails = useSelector((state: any) => {
    return state.asset.assetDetails;
  });

  useEffect(() => {
    if (!id || Object.keys(assetDetails).length) return;
    dispatch(getAssetByCode({ id }));
  }, [id]);

  const location = useLocation();

  useEffect(() => {
    const breadCrumbInfo: BreadCrumbInfoModel[] = [];

    breadCrumbInfo.push(initialBreadcrumb);

    if (assetDetails) {
      breadCrumbInfo.push({
        label: assetDetails.assetId,
        active: false,
        onClick: () => navigateTo(`/asset/${btoa(assetDetails.assetId)}`),
      });

      const formattedPart = getFormattedRouteEndPart(location.pathname);

      breadCrumbInfo.push({
        label: formattedPart,
        active: true,
      });
    }

    setBreadCrumbInfo(breadCrumbInfo);
  }, [assetDetails, location]);

  useEffect(() => {
    const url = window.location.href;

    const parentMenuPath = url.split("/")[url.split("/").length - 2];

    switch (parentMenuPath) {
      case "light-parameters":
        setSideNavIdentifier("Light Parameters");
        break;
      case "sensor-parameters":
        setSideNavIdentifier("Sensor Parameters");
        break;
      case "light-profile":
        setSideNavIdentifier("Light Profile");
        break;

      default:
        break;
    }
  }, []);

  return (
    <div>
      <div className="header-container">
        <div className="title-container">
          <ContentHeader
            pageTitle={breadCrumbInfo[breadCrumbInfo.length - 1]?.label}
          />
        </div>
      </div>

      <div className="page">
        <div className="page-container mt-4">
          <BreadcrumbComponent breadCrumbInfo={breadCrumbInfo} />
          <div className="flex justify-between">
            {sideNavIdentifier && sideNavIdentifier === "Light Profile" ? (
              <div className="w-lg-25">
                <AssetActionSideBarComponent
                  moduleName={sideNavIdentifier}
                  isAccordion={false}
                />
              </div>
            ) : null}
            <div
              className={`${sideNavIdentifier === "Light Profile" ? "w-lg-75" : "w-100"
                }`}
              style={
                sideNavIdentifier === "Light Profile"
                  ? { marginLeft: "1rem" }
                  : {}
              }
            >
              <Outlet />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AssetActionComponent;
